import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Oppsummering } from "src/app/models/oppsummering.model";

@Injectable({
  providedIn: "root",
})
export class OppsummeringApiService {
  private http = inject(HttpClient);

  getOppsummering(id: string): Observable<Oppsummering> {
    return this.http.get<Oppsummering>(`/api/oppsummering/${id}`);
  }

  getPdf(id: string) {
    return this.http.get(`/api/resultat/${id}/pdf`, { responseType: "blob" });
  }
}
